import React, { Component } from 'react';

import SelectCommon from '../../NuevaSolicitudCuenta/components/Common/SelectCommonDefault'
import { debug } from 'util';

class Distribucion extends Component {
    constructor(props){
        super(props)
        this.state={
            seleccionTitular:this.props.data.SelectCodigoDistribucionClienteAdicional,
        }
    }
    // componentWillMount(){
    //     if(this.props.tarjetas.solicitudCuenta.distribucionTitularId){
    //         this.props.selectCombo("SelectCodigoDistribucionClienteAdicional",this.props.tarjetas.solicitudCuenta.distribucionTitularId )                    
    //         this.setState({
    //                 seleccionTitular:this.props.tarjetas.solicitudCuenta.distribucionTitularId
    //             }) 
    //     }
    // }

    // componentWillReceiveProps(nextprops, props){
    //     if(nextprops.data.SelectCodigoDistribucionClienteAdicional !==  this.props.tarjetas.solicitudCuenta.distribucionTitularId){
    //         this.setState({
    //             seleccionTitular:nextprops.data.SelectCodigoDistribucionClienteAdicional
    //         })
    //     } 
    // }
    componentDidMount(){
        if(this.props.tarjetas.solicitudCuenta.distribucionTitularId){
                    this.props.selectCombo("SelectCodigoDistribucionClienteAdicional",this.props.tarjetas.solicitudCuenta.distribucionTitularId )                    
                    this.setState({
                            seleccionTitular:this.props.tarjetas.solicitudCuenta.distribucionTitularId
                        }) 
                }
    }
    componentWillReceiveProps(nextprops){

            if(nextprops.data.SelectCodigoDistribucionClienteAdicional !==  this.props.tarjetas.solicitudCuenta.distribucionTitularId){
                this.setState({
                    seleccionTitular:nextprops.data.SelectCodigoDistribucionClienteAdicional
                })
            } 
        
    }
    render() {
        const {data, tarjetas, selectCombo}=this.props
       
        const{solicitudCuenta}=tarjetas

        //SI HAY UNA SELECCIÓN DE CÓDIGO DE DISTRIBUCIÓN PARA LA CUENTA EN GENERAL, SE USARÁ LA MISMA. SINO LA DEFAULT PARA EL PRODUCTO.
        let codigoDefault = 0;

        //SI ES UNA CUENTA EXISTENTE, CÓDIGO DEFAULT ES EL DE LA TARJETA REGISTRADA CON EL ID MÁS ALTO
        if(tarjetas.esCuentaExistente && Array.isArray(data.cuentasAdicionales) && data.cuentasAdicionales.length>0 ){
            let idMayor = 0;
            data.cuentasAdicionales.map(cuenta=>{if(cuenta.Id>idMayor && cuenta.SolicitudId){idMayor = cuenta.Id ; codigoDefault = cuenta.DistribucionId ? cuenta.DistribucionId: 0 } });
        }
        
        if(!tarjetas.esCuentaExistente && solicitudCuenta && solicitudCuenta.ProductoVisaSeleccionadoDatosDefault && codigoDefault == 0){
            if(solicitudCuenta.codigoDistribucionSeleccionadoId){
                codigoDefault = solicitudCuenta.codigoDistribucionSeleccionadoId
            }else if(solicitudCuenta.ProductoVisaSeleccionadoDatosDefault.CodigoDistribucionDefaultInterfaz && solicitudCuenta.ProductoVisaSeleccionadoDatosDefault.CodigoDistribucionDefaultId){
                codigoDefault = solicitudCuenta.ProductoVisaSeleccionadoDatosDefault.CodigoDistribucionDefaultId 
            }
        }
       
        return (
            <div className="row top-separator-xs">
                <div className="col-xs-12">
                    <label className="label-primary">{"Distribución"}</label>
                    <div className="row">
                        <div className="col-xs-5">
                            <SelectCommon 
                                    valorCombo={codigoDefault}
                                    selecciones={data}
                                    infoData={solicitudCuenta.ATLAS_DISTRIBUCION ? solicitudCuenta.ATLAS_DISTRIBUCION : [] } 
                                    selectCombo={selectCombo}
                                    nombreAction={"SelectCodigoDistribucionClienteAdicional"}
                             />
                        </div>
                        <div className="col-md-12">
                            {(data.ERROR_ADICIONAL["seleccionoDistribucion"] == false)
                                && <label className="error">{"Debe seleccionar una distribución"}</label>
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};

export default Distribucion;